module.exports = __webpack_public_path__ + "static/media/apk.08192941.png";